import request from './index'

/**
 * 获取筛选项接口
 * @param {Number} labelGroup - 标签组ID
 * @returns {Promise<ApiResponse>}
 */
export function getFilterOptions(labelGroup) {
  return request({
    url: '/v1/search/filter-options',
    method: 'get',
    params: {
      label_group: labelGroup
    }
  })
}

/**
 * 获取市场端列表接口
 * @param {Object} params - 请求参数，包含 search_params, page, limit
 * @returns {Promise<ApiResponse>}
 */
export function getMarketList(params = {}) {
  return request({
    url: '/v1/search/market',
    method: 'get',
    params: params
  })
}

/**
 * 获取市场端详情接口
 * @param {String|Number} id - 详情ID
 * @returns {Promise<ApiResponse>}
 */
export function getMarketDetail(id) {
  return request({
    url: `/v1/search/market/detail/${id}`,
    method: 'get'
  })
}

/**
 * 获取国家政策列表接口
 * @param {Object} params - 请求参数，包含 search_params, page, limit
 * @returns {Promise<ApiResponse>}
 */
export function getPoliciesList(params = {}) {
  return request({
    url: '/v1/search/policies',
    method: 'get',
    params: params
  })
}

/**
 * 获取国家政策详情接口
 * @param {String|Number} id - 详情ID
 * @returns {Promise<ApiResponse>}
 */
export function getPoliciesDetail(id) {
  return request({
    url: `/v1/search/policies/detail/${id}`,
    method: 'get'
  })
}

/**
 * 获取招投标信息列表接口
 * @param {Object} params - 请求参数，包含 search_params, page, limit
 * @returns {Promise<ApiResponse>}
 */
export function getBiddingList(params = {}) {
  return request({
    url: '/v1/search/bidding',
    method: 'get',
    params: params
  })
}

/**
 * 获取招投标信息详情接口
 * @param {String|Number} id - 详情ID
 * @returns {Promise<ApiResponse>}
 */
export function getBiddingDetail(id) {
  return request({
    url: `/v1/search/bidding/detail/${id}`,
    method: 'get'
  })
}

/**
 * 获取前沿技术列表接口
 * @param {Object} params - 请求参数，包含 search_params, page, limit
 * @returns {Promise<ApiResponse>}
 */
export function getNewTechList(params = {}) {
  return request({
    url: '/v1/search/new-tech',
    method: 'get',
    params: params
  })
}

/**
 * 获取前沿技术详情接口
 * @param {String|Number} id - 详情ID
 * @returns {Promise<ApiResponse>}
 */
export function getNewTechDetail(id) {
  return request({
    url: `/v1/search/new-tech/detail/${id}`,
    method: 'get'
  })
}

/**
 * 获取器械注册列表接口
 * @param {Object} params - 请求参数，包含 search_params, page, limit
 * @returns {Promise<ApiResponse>}
 */
export function getDeviceList(params = {}) {
  return request({
    url: '/v1/search/device',
    method: 'get',
    params: params
  })
}

/**
 * 获取器械注册详情接口
 * @param {String|Number} id - 详情ID
 * @returns {Promise<ApiResponse>}
 */
export function getDeviceDetail(id) {
  return request({
    url: `/v1/search/device/detail/${id}`,
    method: 'get'
  })
}

/**
 * 获取临床研究列表接口
 * @param {Object} params - 请求参数，包含 search_params, page, limit
 * @returns {Promise<ApiResponse>}
 */
export function getClinicalList(params = {}) {
  return request({
    url: '/v1/search/clinical',
    method: 'get',
    params: params
  })
}

/**
 * 获取临床研究详情接口
 * @param {String|Number} id - 详情ID
 * @returns {Promise<ApiResponse>}
 */
export function getClinicalDetail(id) {
  return request({
    url: `/v1/search/clinical/detail/${id}`,
    method: 'get'
  })
}

/** 高级检索字段配置 GET /v1/search/advanced-search-config */
export function getAdvancedSearchConfig(labelGroup) {
  return request({
    url: '/v1/search/advanced-search-config',
    method: 'get',
    params: { label_group: labelGroup },
  })
}

const ADVANCED_SEARCH_PATHS = {
  1: '/v1/search/market',
  2: '/v1/search/policies',
  3: '/v1/search/bidding',
  4: '/v1/search/new-tech',
  5: '/v1/search/device',
  6: '/v1/search/clinical',
}

/** 按 create_time 区间查询（MySQL，不走 ES） */
const BY_DATE_SEARCH_PATHS = {
  1: '/v1/search/market/by-date',
  2: '/v1/search/policies/by-date',
  3: '/v1/search/bidding/by-date',
  4: '/v1/search/new-tech/by-date',
  5: '/v1/search/device/by-date',
  6: '/v1/search/clinical/by-date',
}

/**
 * 六类数据按时间查询
 * GET /v1/search/{type}/by-date
 * @param {Number|String} labelGroup
 * @param {{ start_date: string, end_date: string, page?: number, limit?: number }} params
 */
export function getDataByDate(labelGroup, params = {}) {
  const url = BY_DATE_SEARCH_PATHS[Number(labelGroup)]
  if (!url) {
    return Promise.reject(new Error(`不支持的数据集 label_group=${labelGroup}`))
  }
  return request({
    url,
    method: 'get',
    params,
  })
}

/** 执行高级检索 POST，body 含 advance_query / page / limit / conditions */
export function postAdvancedSearch(labelGroup, body) {
  const url = ADVANCED_SEARCH_PATHS[Number(labelGroup)]
  if (!url) {
    return Promise.reject(new Error(`不支持的数据集 label_group=${labelGroup}`))
  }
  return request({
    url,
    method: 'post',
    data: body,
  })
}

export function getAdvancedSearchPath(labelGroup) {
  return ADVANCED_SEARCH_PATHS[Number(labelGroup)] || '/v1/search/device'
}

